<template>
  <!-- ヘッダー -->
  <MFITTHeader
    header-title="引換券の選択"
    :click-back-button-event="backToMfittIndexPage"
  />

  <!-- 所持しているクーポンの一覧 -->
  <MFITTCouponList
    v-model:selectedCoupon="selectedCoupon"
    :my-coupon="myCoupons"
  />

  <!-- 有効なクーポンがない場合はバナーを表示 -->
  <MFITTCouponNotification v-if="checkNoCoupons()" />

  <!-- 次ページへのアクションボタン -->
  <div class="foot-button-block">
    <ItemButton
      :is-disabled="isDisabled"
      :action-type="actionType"
      label="次へ"
      @clicked="goToBooking1"
    />
  </div>
</template>

<script>
import { computed, ref, watchEffect } from "vue";

import { useStore } from "vuex";
import { useRouter } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateMfittSelectCoupon",

  setup() {
    const store = useStore();
    const router = useRouter();

    const isDisabled = ref(true);
    const actionType = ref("disabled");

    // 所持しているクーポン
    const myCoupons = computed(() => store.getters["MFITT/myCoupons"]);

    // 選択されたクーポン
    const selectedCoupon = ref("");

    // headerのbackButton用の処理。
    const backToMfittIndexPage = () => {
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    // 有効なサブスクチケットを持っているかチェック。
    const checkNoCoupons = () => {
      const subScriptionCoupons = myCoupons.value.filter(
        (coupon) => coupon.type === "subscription"
      );

      const availableCoupons = myCoupons.value.filter(
        (coupon) =>
          coupon.type === "subscription" &&
          coupon.is_exchangeable &&
          coupon.used_count < coupon.use_limit
      );

      // サブスクチケットを使い切った時だけtrueを返却。
      return subScriptionCoupons.length > 0 && availableCoupons.length === 0;
    };

    // ロマンスカー特急券予約・購入ページへ
    const goToBooking1 = () => {
      if (selectedCoupon.value === "none") {
        router.push({
          name: "MfittBooking1",
        });
      } else {
        router.push({
          name: "MfittBooking1",
          query: { coupon_id: selectedCoupon.value },
        });
      }
    };

    watchEffect(() => {
      // クーポン選択画面で選択されたらロマンスカー特急券予約・購入ページへに進める
      if (selectedCoupon.value) {
        actionType.value = "btn-primary";
        isDisabled.value = false;
      } else {
        actionType.value = "disabled";
        isDisabled.value = true;
      }
    });

    return {
      isDisabled,
      actionType,
      myCoupons,
      selectedCoupon,
      backToMfittIndexPage,
      checkNoCoupons,
      goToBooking1,
    };
  },
};
</script>

<style socped>
.mb-inquiry {
  margin-bottom: 160px;
}

.form {
  margin: 20px 15px;
}

.foot-button-block {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 90%;
  bottom: 0;
  background-color: #ffffff;
  padding: 15px 15px 20px 15px;
}
</style>
